<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          処分方法
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row>
    <!-- /ヘッダー -->

    <v-row>
      <v-col class="text-right">
        <v-btn
          color="info"
          @click="addButtonClickEvent"
        >
          処分方法の追加
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="disposers"
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.created_at`]="{ item }">
                {{ item.created_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.updated_at`]="{ item }">
                {{ item.updated_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.editable`]="{ item }">
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  icon
                  color="cyan darken-2"
                  @click="showButtonClickEvent(item)"
                >
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="cyan"
                  @click="showButtonClickEvent(item)"
                >
                  参照する
                </v-btn>
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  color="cyan darken-2"
                  icon
                  @click="editButtonClickEvent(item)"
                >
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="cyan"
                  @click="editButtonClickEvent(item)"
                >
                  編集する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row dense>
      <v-col>
        <v-pagination
          v-model="current_page"
          :length="10"
          circle
          :total-visible="5"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
  </div>
</template>

<script>
export default {
  name: 'AdminMasterDisposerIndex',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      current_page: 1,
      tableHeaders: [
        { value: 'code', text: 'コード' },
        { value: 'name', text: '名称' },
        { value: 'created_at', text: 'データ作成日時' },
        { value: 'updated_at', text: 'データ更新日時' },
        { value: 'position', text: '表示順', align: 'right' },
        { value: 'editable', text: '', align: 'end' }
      ],
      disposers: [
        {
          id: 1,
          code: '100',
          name: '再生',
          position: 1,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 2,
          code: '101',
          name: '再使用(リユース)',
          position: 2,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 3,
          code: '102',
          name: '素材再生',
          position: 3,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 4,
          code: '103',
          name: '他用途原材料化',
          position: 4,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 5,
          code: '104',
          name: '燃料化',
          position: 5,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 6,
          code: '105',
          name: 'コンポスト化(堆肥化)',
          position: 6,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 7,
          code: '106',
          name: 'その他再生',
          position: 7,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 8,
          code: '200',
          name: '中間処理',
          position: 8,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 9,
          code: '201',
          name: '脱水',
          position: 9,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 10,
          code: '202',
          name: '機械乾燥',
          position: 10,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
      ]
    }
  },
  computed: {},
  created() {
  },
  methods: {
    addButtonClickEvent () {
      this.$router.push({name: 'AdminMasterDisposalMethodNew'})
    },
    showButtonClickEvent (item) {
      this.$router.push({name: 'AdminMasterDisposalMethod', params: {id: item.id}})
    },
    editButtonClickEvent (item) {
      this.$router.push({name: 'AdminMasterDisposalMethodEdit', params: {id: item.id}})
    }
  }
}
</script>

<style scoped>

</style>
